import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router';

const TopPage = lazy(() => import('./pages/TopPage'));
const SongSearchPage = lazy(() => import('./pages/SongSearchPage'));
const SongDetailPage = lazy(() => import('./pages/SongDetailPage'));
const SongDownloadPage = lazy(() => import('./pages/SongDownloadPage'));
const ComposerSearchPage = lazy(() => import('./pages/ComposerSearchPage'));
const ComposerDetailPage = lazy(() => import('./pages/ComposerDetailPage'));
const InformationPage = lazy(() => import('./pages/InformationPage'));
const LicensePage = lazy(() => import('./pages/LicensePage'));
const AgreementPage = lazy(() => import('./pages/AgreementPage'));
const YouTubePage = lazy(() => import('./pages/YouTubePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

/** ページ遷移・検索条件 (クエリ) の変更時に先頭へスクロール (ハッシュ付きリンクは対象外) */
function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, search, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<TopPage />} />
          <Route path="/songs" element={<SongSearchPage />} />
          <Route path="/songs/:slug" element={<SongDetailPage />} />
          <Route path="/songs/:slug/download" element={<SongDownloadPage />} />
          <Route path="/composers" element={<ComposerSearchPage />} />
          <Route path="/composers/:slug" element={<ComposerDetailPage />} />
          <Route path="/information" element={<InformationPage />} />
          <Route path="/license" element={<LicensePage />} />
          <Route path="/agreement" element={<AgreementPage />} />
          <Route path="/youtube" element={<YouTubePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  );
}
